import Column from '@components/Column';
import CtaLayout from '@components/CtaLayout';
import Divider from '@components/Divider';
import Header from '@components/Header';
import TermNotes from '@components/term/TermNotes';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import CardInfo from './components/CardInfo';
import PurchaseButton from './components/PurchaseButton';
import Summary from './components/Summary';
import useInitialValues from './hooks/useInitialValues';
import PaymentMethod from '../_shared/components/PaymentMethod';

interface Params {
    prepaidCardImageId: string;
    cardName?: string;
    amount?: number;
}

const PrepaidCardImageActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { t } = useTranslation('prepaidCard');
    const { prepaidCardImageId, cardName, amount } = params;
    useInitialValues({ cardName, amount });
    return (
        <AppScreen>
            <CtaLayout header={<Header title={t('image.title')} />}
                footer={<PurchaseButton prepaidCardImageId={prepaidCardImageId}/>} >
                <Column fullWidth>
                    <Summary prepaidCardImageId={prepaidCardImageId}/>
                    <CardInfo/>
                    <PaymentMethod/>
                    <Divider/>
                    <TermNotes displayContext='PREPAY' />
                </Column>
            </CtaLayout>
        </AppScreen>
    );
};

export default PrepaidCardImageActivity;
